import { redirect, type MiddlewareFunction } from 'react-router';
import services from '../../services/index';
import { BOKA_QUERY_PARAMS, getAppPageFromPath } from '../../helpers/urlHelper';
import { getServiceUnavailablePath } from '../../helpers/serviceUnavailableHelper';
import { viewContext } from './context';
import { hasAppViewAccessToken } from '../../helpers/cookieHelper';
import { isInsideIframe } from '../../helpers/browserHelper';

let initialServiceCheckDone = false;

const serviceUnavailableMiddleware: MiddlewareFunction = async ({
  request,
  context,
}) => {
  if (initialServiceCheckDone) {
    return;
  }
  initialServiceCheckDone = true;

  const view = context.get(viewContext);
  const url = new URL(request.url);
  const page = getAppPageFromPath(url.pathname);

  if (page === 'service-unavailable' || page === 'not-found') {
    return;
  }

  if (
    view === 'app' &&
    !hasAppViewAccessToken() &&
    new URLSearchParams(window.location.search).get(
      BOKA_QUERY_PARAMS.TEST_MODE,
    ) !== 'true'
  ) {
    throw redirect(getServiceUnavailablePath(true));
  }

  // Alt view is meant to be embedded in an iframe. If it's loaded
  // standalone (e.g. someone opens the /alt/ URL directly), redirect
  // to service-unavailable unless test_mode bypasses the check.
  if (
    view === 'alt' &&
    !isInsideIframe() &&
    new URLSearchParams(window.location.search).get(
      BOKA_QUERY_PARAMS.TEST_MODE,
    ) !== 'true'
  ) {
    throw redirect(getServiceUnavailablePath(true));
  }

  try {
    const statusResponse = await services.status.getStatus();
    if (statusResponse.status === 503) {
      throw redirect(getServiceUnavailablePath(true));
    }
  } catch {
    throw redirect(getServiceUnavailablePath(true));
  }

  if (MAINTENANCE_MODE === 'true') {
    throw redirect(getServiceUnavailablePath(true));
  }
};

export default serviceUnavailableMiddleware;
